import { useMutation } from '@apollo/client';
import { LOGIN_EMAIL } from '../GraphQL/Mutations';
import { USER_TOKEN } from '../Constants/AppConstants';
import useUpdateCurrentUser from './useUpdateCurrentUser';

const useUserSession = () => {
  const updateUser = useUpdateCurrentUser();
  const [mutate, { loading, error }] = useMutation(LOGIN_EMAIL, {
    onCompleted: (data) => {
      localStorage.setItem(USER_TOKEN, data.loginEmail.authenticationToken);
      updateUser(data.loginEmail.user);
    },
  });

  const login = (email) => {
    mutate({
      variables: {
        email,
      },
    });
  };

  return { login, loading, error };
};

export default useUserSession;
